import { createContext, useContext, useEffect, useState } from "react"

import { searchItems } from "../../properties/components/tailwindSandbox"
import { UTILITIES_BY_GROUP } from "../predefined_sizes"

const UtilitiesContext = createContext()

export const UtilitiesProvider = ({ children }) => {
  const [utilitiesContext, setUtilitiesContext] = useState({ rightClick: {}, items: UTILITIES_BY_GROUP })

  const handleCloseContextMenu = () => {
    setUtilitiesContext({ ...utilitiesContext, rightClick: {} })
  }

  useEffect(() => {
    const query = utilitiesContext.search
    const items = searchItems({ query, defaultItems: UTILITIES_BY_GROUP, keysToSearch: ['value', 'label', 'category'] })
    if (items.length !== utilitiesContext.items.length) {
      setUtilitiesContext({ ...utilitiesContext, items })
    }
  }, [utilitiesContext.search, utilitiesContext])

  return <UtilitiesContext.Provider value={{ utilitiesContext, setUtilitiesContext, onCloseContextMenu: handleCloseContextMenu }}>
    {children}
  </UtilitiesContext.Provider>
}

export const useUtilitiesContext = () => useContext(UtilitiesContext)
